import React, { useRef, useState } from 'react';
import styles from '../../styles/flyouts/tenders/Files.scss';
import { withRouter } from 'react-router';
import {
  __,
  bytesToSize,
  dateFrom,
  scrollToBottom,
  timeFrom,
} from '../../core/utils';
import * as _ from 'lodash';
import ReactDropzone from 'react-dropzone';
import classNames from 'classnames';
import UploadIcon from '../../assets/images/upload-40x40.svg';
import { setNotification } from '../../redux/actions/general/notification';
import {
  hideAlertbox,
  showAlertbox,
} from '../../redux/actions/general/alertbox';
import FilePreview from '../../components/FilePreview';
import Avatar from '../../components/Avatar';
import {
  listAllTenders,
  uploadTenderFiles,
} from '../../redux/actions/table/tenders';
import { connect } from 'react-redux';
import { hideDropdown } from '../../redux/actions/general/dropdown';
import {
  archiveAttachment,
  deleteAttachmentCurrentVersion,
  unarchiveAttachment,
} from '../../redux/actions/attachments';
import AttachmentFileMenu from '../../components/AttachmentFileMenu';
import { setAttachmentParams } from '../../redux/actions/general/attachments';
import Dropdown from '../../components/Dropdown';
import { linkFilesToModel } from '../../redux/actions/table/files';

const Files = (props) => {
  const [drag, setDrag] = useState();
  const [showArchivedFiles, setShowArchivedFiles] = useState(false);
  const scroll = useRef();
  const dropzone = useRef();

  const _handleDrop = (acceptedFiles, rejectedFiles) => {
    setDrag(false);
    const { data } = props;

    if (!_.isEmpty(acceptedFiles)) {
      if (_.size(rejectedFiles) > 1) {
        setNotification({
          text: __('tenders.files.upload.bulk-not-allowed'),
          type: 'warning',
        });
      } else if (!_.isEmpty(rejectedFiles)) {
        setNotification({
          text: __('tenders.files.upload.incorrect.format'),
          type: 'warning',
        });
      } else if (
        _.find(acceptedFiles, (file) => {
          return file.size >= 100000000;
        })
      ) {
        setNotification({
          text: __('tenders.files.upload.upload-limit'),
          type: 'warning',
        });
      } else {
        setNotification(__('tenders.files.upload.uploading'));

        uploadTenderFiles(data.id, acceptedFiles)
          .then(() => {
            setNotification(__('tenders.files.upload.uploaded'));

            props.match.params.stage &&
              listAllTenders(props.match.params.stage);

            props.readAction(data.id).then(() => {
              scrollToBottom(scroll.current);
            });
          })
          .catch(({ status }) => {
            setNotification({
              text: __('tenders.files.upload.upload-limit'),
              type: 'warning',
            });
          });
      }
    }
  };

  const _downloadFile = (row, download = false) => {
    if (row.ext == 'pdf' && download == false) {
      window.open(row.stream_url, '_blank');
    } else {
      setNotification(__('tenders.files.download.continue'));

      window.open(row.download_url, '_blank');
    }
  };

  const _refreshTender = () => {
    const { data } = props;

    return props.readAction(data.id).then(() => {
      scrollToBottom(scroll.current);
    });
  };

  const _openEditAttachment = (row) => {
    hideDropdown();

    setAttachmentParams({
      edit_attachment_wizard: row,
      attachment_context: {
        type: 'tender',
        tender_id: props.data.id,
      },
    });

  };

  const _openUploadAttachmentVersion = (row) => {
    hideDropdown();

    setAttachmentParams({
      upload_attachment_version_wizard: row,
      attachment_context: {
        type: 'tender',
        tender_id: props.data.id,
      },
    });

  };

  const _archiveAttachment = (row) => {
    const is_archived = !!row.archived;
    const update_archive = is_archived
      ? unarchiveAttachment
      : archiveAttachment;

    hideDropdown();

    showAlertbox({
      color: 'blue',
      title: __('general.alert.are-you-sure'),
      description: is_archived
        ? __(
            'attachments.alert.unarchive-file',
            {},
            'Are you sure you want to unarchive this file?'
          )
        : __(
            'attachments.alert.archive-file',
            {},
            'Are you sure you want to archive this file?'
          ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: is_archived
            ? __('attachments.button.unarchive', {}, 'Unarchive')
            : __('attachments.button.archive', {}, 'Archive'),
          onClick: () => {
            update_archive(row.attachment_id).then(() => {
              hideAlertbox();
              setNotification(
                is_archived
                  ? __(
                      'attachments.notification.unarchived',
                      {},
                      'File unarchived.'
                    )
                  : __(
                      'attachments.notification.archived',
                      {},
                      'File archived.'
                    )
              );
              _refreshTender();
            });
          },
        },
      ],
    });
  };

  const _deleteFile = (row) => {
    hideDropdown();

    showAlertbox({
      color: 'red',
      title: __('general.alert.are-you-sure'),
      description: __(
        'files.general.alert.want-delete-file-attachment-tender.process-cannot-undone'
      ),
      buttons: [
        {
          color: 'lightGray',
          text: __('general.alert.no-close'),
          onClick: 'close',
        },
        {
          color: 'gray',
          text: __('general.alert.yes-delete'),
          onClick: () => {
            deleteAttachmentCurrentVersion(row.attachment_id).then(() => {
              hideAlertbox();

              setNotification(
                __('files.notification.selected-file-attachment-deleted-tender')
              );

              _refreshTender();
            });
          },
        },
      ],
    });
  };

  const _openUploadPicker = () => {
    hideDropdown();

    if (dropzone.current) {
      dropzone.current.open();
    }
  };

  const _openLinkExistingFilesWizard = () => {
    const { data } = props;
    const stage_id = props.match.params.stage;

    hideDropdown();
    setAttachmentParams({
      link_existing_files_wizard: {
        stage_id,
        linked_file_ids: _.map(data.files, 'attachment_id'),
        onLinkFiles: (file_ids) =>
          linkFilesToModel(stage_id, 'Tender', data.id, file_ids).then(
            () => {
              props.readAction(data.id).catch(_.noop);
              listAllTenders(stage_id).catch(_.noop);
            }
          ),
      },
    });
  };

  const { data, collapsed, files, disabled } = props;
  const sorted_files = _.sortBy(files, ['created_at']);
  const archivedFilesCount = _.size(
    _.filter(sorted_files, (file) => file.archived)
  );
  const visibleFiles = showArchivedFiles
    ? sorted_files
    : _.filter(sorted_files, (file) => !file.archived);

  const lightbox_images = _.map(
    _.filter(visibleFiles, (file) =>
      _.includes(['jpg', 'jpeg', 'png', 'pdf'], _.toLower(file.ext))
    ),
    (file) => ({
      id: file.id,
      attachment_version_id: file.attachment_version_id,
      stream_url: file.stream_url,
      title: [file.name, file.ext].join('.'),
      download_url: file.download_url,
      ext: file.ext,
      width: file.width,
      height: file.height,
    })
  );

  return (
    <div
      className={classNames(styles.wrapper, collapsed && styles.collapsed)}
      ref={scroll}
    >
      {!_.isEmpty(sorted_files) && (
        <div className={styles.actions}>
          <label className={styles.showArchivedFiles}>
            {archivedFilesCount > 0 ? (
              <>
                <span>
                  {__('tenders.files.show-hide-archived-files')}{' '}
                  {'(' + archivedFilesCount + ')'}
                </span>
                <input
                  type='checkbox'
                  checked={showArchivedFiles}
                  onChange={(e) => setShowArchivedFiles(e.target.checked)}
                />
              </>
            ) : (
              <span>{__('tenders.files.no-archived-files')}</span>
            )}
          </label>
        </div>
      )}
      <div className={styles.scroller}>
        {_.isEmpty(visibleFiles) ? (
          <div className={styles.empty}>
            {__('tenders.flyout.files.there-are-no-files')}
          </div>
        ) : (
          ''
        )}

        {_.map(visibleFiles, (row) => {
          return (
            <div
              className={classNames(
                styles.row,
                row.archived && styles.archived
              )}
              key={row.attachment_id || row.id}
            >
              <div className={styles.left}>
                <FilePreview
                  onDownloadFile={_downloadFile}
                  row={row}
                  lightbox_images={lightbox_images}
                />
              </div>
              <div className={styles.right}>
                <span className={styles.version}>{'V' + row.version}</span>

                <span className={styles.size}>{bytesToSize(row.size)}</span>

                <div className={styles.avatar}>
                  <Avatar
                    size={24}
                    {...row.creator}
                    avatar_url={_.get(row, 'creator.avatar_url')}
                    className={styles.avatar}
                  />
                </div>

                <div className={styles.date_time}>
                  {dateFrom(row.current_version_created_at || row.created_at)}
                  <br />
                  {timeFrom(row.current_version_created_at || row.created_at)}
                </div>
                <div className={styles.icons}>
                  <AttachmentFileMenu
                    name={'tender_file_menu_' + (row.attachment_id || row.id)}
                    row={row}
                    canManageFile={!disabled}
                    canVersionFile={!disabled}
                    onDownloadFile={_downloadFile}
                    onOpenEdit={_openEditAttachment}
                    onOpenUploadVersion={_openUploadAttachmentVersion}
                    onArchiveAttachment={_archiveAttachment}
                    onDeleteFile={_deleteFile}
                  />
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {!disabled && (
        <ReactDropzone
          ref={(dropzoneElement) => {
            dropzone.current = dropzoneElement;
          }}
          className={classNames(styles.dropzone, drag && styles.drag)}
          disableClick
          onDrop={_handleDrop}
          onDragOver={() => setDrag(true)}
          onDragLeave={() => setDrag(false)}
          multiple={true}
        >
          <UploadIcon />
          <span className={styles.dropTitle}>
            {__('dropzone.title.drop-your-file-here')}
          </span>
          <Dropdown
            portal
            top={28}
            right={0}
            name={'tender_add_files_' + data.id}
            wrapperClassName={styles.addFilesDropdownWrapper}
            dropdownClassName={styles.addFilesDropdown}
            content={
              <div className={styles.addFilesMenu}>
                <div
                  className={styles.addFilesOption}
                  onClick={_openLinkExistingFilesWizard}
                >
                  {__('tenders.flyout.files.browse-from-volum3')}
                </div>
                <div
                  className={styles.addFilesOption}
                  onClick={_openUploadPicker}
                >
                  {__('tenders.flyout.files.upload-new')}
                </div>
              </div>
            }
          >
            <span className={styles.dropSubtitle}>
              {__('tenders.flyout.files.add-files')}
            </span>
          </Dropdown>
        </ReactDropzone>
      )}
      {/* {!disabled && (
        <ReactDropzone
          className={classNames(styles.dropzone, drag && styles.drag)}
          onDrop={_handleDrop}
          onDragOver={() => setDrag(true)}
          onDragLeave={() => setDrag(false)}
          multiple={true}
          disabled={disabled}
        >
          <UploadIcon />
          <span className={styles.dropTitle}>
            {__('dropzone.title.drop-your-file-here')}
          </span>
          <span className={styles.dropSubtitle}>
            {__('dropzone.title.or-select')}
          </span>
        </ReactDropzone>
      )} */}
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user_id: state.auth.id,
    clicked_row: _.get(state.table, ['tenders', 'clicked_row']),
    wizard_active: _.get(state.table, ['tenders', 'wizard_active']),
  };
};

export default withRouter(connect(mapStateToProps, null)(Files));
